<template>
    <div class="layout-topbar">
        <Toast />

        <div class="topbar-content">
            <div class="inner-toolbar p-my-1" style="display: flex">
                <div style="display: flex; width: 75%">
                    <button class="p-link layout-menu-button layout-topbar-icon" @click="onMenuButtonClick">
                        <i class="pi pi-bars"></i>
                    </button>
                    <a class="main-logo" href="#">
                        <img class="logo-item-inner p-mx-1 p-my-1" alt="logo" :src="logoUrl" />
                    </a>

                    <div class="layout-topbar-search" style="width: 100%">
                        <InputGroup>
                            <InputText
                                placeholder="Search YUZANER.COM"
                                v-model="searchQuery"
                                @keyup.enter="onKeywordSearch"
                                style="border-top-right-radius: 0; border-bottom-right-radius: 0; vertical-align: middle; outline-width: 0; box-shadow: none"
                            />
                            <InputGroupAddon>
                                <Button icon="pi pi-search" :class="searchQuery.length > 3 ? 'p-button-success' : 'p-button-warning'" @click="onKeywordSearch" style="vertical-align: middle; border-top-left-radius: 0; border-bottom-left-radius: 0" />
                            </InputGroupAddon>
                        </InputGroup>
                    </div>
                </div>

                <div style="display: flex">
                    <button class="p-link layout-topbar-icon" @click="toggleAccountPanel">
                        <i v-if="$store.state.user.userData?.name" class="logo-item2 topbar-icon pi pi-fw pi-user-edit" />
                        <i v-else class="logo-item2 topbar-icon pi pi-fw pi-user" />
                    </button>
                    <OverlayPanel ref="acc">
                        <div style="min-width: 150px">
                            <div class="panel-menu-item">
                                <button class="p-link panel-menu-sub-item" @click="$store.state.user.userData ? gotoProfile($event) : gotoLogin($event)">
                                    <i class="pi pi-fw pi-user"></i>&nbsp;
                                    <span>Profile</span>
                                </button>
                            </div>
                            <div class="panel-menu-item" v-if="$store.state.user.userData">
                                <button class="p-link panel-menu-sub-item" @click="logout($event)">
                                    <i class="pi pi-fw pi-sign-out"></i>&nbsp;
                                    <span>Sign Out</span>
                                </button>
                            </div>
                        </div>
                    </OverlayPanel>
                    <button class="p-link layout-topbar-icon" @click="toggleCartPanel($event)">
                        <i v-if="$store.state.cart?.totalItems > 0 && $store.state.cart?.totalItems <= 99" class="logo-item2 pi pi-fw pi-shopping-cart shopping-cart-badge" v-badge="$store.state.cart.totalItems" />
                        <i v-else-if="$store.state.cart?.totalItems > 99" class="logo-item2 pi pi-fw pi-shopping-cart shopping-cart-badge" v-badge="'99+'" />
                        <i v-else class="logo-item2 pi pi-fw pi-shopping-cart" />
                    </button>
                    <OverlayPanel ref="cart">
                        <div style="min-width: 200px; max-width: 200px">
                            <div class="panel-menu-item">

                                <div style="display: flex; align-items: center">
                                    <span style="font-size: 1.4rem; font-weight: bold">{{ $store.state.i18n.messageBundle?.main_menu?.my_cart }}</span>
                                </div>

                                <div style="display: flex; align-items: center" class="p-mt-3">
                                    <Chip size="small" style="background-color: var(--orange-300); padding-top: 5px; padding-bottom: 5px">
                                        <div style="display: flex; align-items: center">
                                            <i style="font-size: small" class="pi pi-fw pi-cart-arrow-down" />&nbsp;<span>{{ $store.state.cart?.totalItems }}</span>
                                        </div>
                                    </Chip>
                                </div>

                                <div v-if="$store.state.cart?.totalItems > 0" style="display: flex; align-items: center" class="p-my-3">
                                    <Chip size="small" style="background-color: var(--green-300); padding-top: 5px; padding-bottom: 5px">
                                        <div style="display: flex; align-items: center">
                                            <i style="font-size: small" class="pi pi-fw pi-money-bill" />&nbsp;<span>{{ ($currency()?.display ? '' + $currency()?.display + ' ' : '') + cartTotalValue }}</span>
                                        </div>
                                    </Chip>
                                </div>

                                <hr/>
                            </div>
                            <div class="p-grid p-fluid p-mx-3">
                                <Button v-if="$store.state.cart?.totalItems > 0" icon="pi pi-cart-arrow-down" 
                                    class="p-button-sm p-button-info" :label="$store.state.i18n.messageBundle?.common?.check_shopping_cart" @click="gotoShoppingCart($event)">
                                </Button>
                                <Button v-else icon="pi pi-tags" class="p-button-sm p-button-info" 
                                    :label="$store.state.i18n.messageBundle?.common?.browse_products" @click="gotoProducts($event)"> </Button>
                            </div>
                        </div>
                    </OverlayPanel>
                    <button v-if="$store.state.i18n.languageSelectionFlag" class="p-link layout-topbar-icon topbar-menu" @click="toggleI18NPanel">
                        <i class="logo-item2 pi pi-fw pi-flag" :class="$store.state.i18n.locale === 'en_US' ? 'en-us-badge' : 'mm-mm-badge'" v-badge="'&nbsp;'"></i>
                    </button>
                    <OverlayPanel ref="i18n">
                        <div style="min-width: 150px">
                            <div class="panel-menu-item">
                                <button class="p-link panel-menu-sub-item" @click="selectMmMM($event)">
                                    <span style="display: flex; flex-direction: row; align-items: start">
                                        <span class="mm-mm-badge-img" style="justify-content: flex-start">&nbsp;</span>
                                        <span style="justify-content: flex-start">{{ $store.state.i18n.messageBundle.common?.lan_mm }}</span>
                                    </span>
                                </button>
                            </div>
                            <div class="panel-menu-item">
                                <button class="p-link panel-menu-sub-item" @click="selectEnUs($event)">
                                    <span style="display: flex; flex-direction: row">
                                        <span class="en-us-badge-img" style="justify-content: center">&nbsp;</span>
                                        <span style="justify-content: center">English</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </OverlayPanel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPanel from './components/usr/NotificationPanel.vue';
import AuthService from './service/AuthService';
import NotificationService from './service/NotificationService';

export default {
    name: 'AppTopBar',

    components: { NotificationPanel },

    emits: ['menubutton-click', 'topbar-menubutton-click', 'topbar-item-click', 'right-menubutton-click'],

    props: {
        title: String,
        topbarMenuActive: Boolean,
        activeTopbarItem: String,
        inlineUser: Boolean,
    },

    data() {
        return {
            searchQuery: '',
            logoUrl: '/assets/logo-main.svg',
            unreadCount: 0,
            notiFlag: true,
            languages: [
                { name: 'EN', code: 'en_US' },
                { name: 'MM', code: 'mm_MM' },
            ],
        };
    },

    watch: {
        $route(to) {
            if (to.path !== '/search') {
                this.searchQuery = '';
            }
        },
    },

    created() {
        this.$retrieveCart();
        if (process.env.VUE_APP_ENV !== 'PRD') {
            //this.logoUrl = '/assets/yuzaner-transparent-logo.svg';
            //this.logoUrl = '/assets/logo-common.svg';
            this.logoUrl = '/assets/logo-staging.svg';
        }

        this.authService = new AuthService();
        this.notiService = new NotificationService();
        this.notiFlag = process.env.VUE_APP_NOTI_AVAILABLE === '1';
        
    },

    mounted() {
        if (this.$store.state.user.userData?.refId) {
            this.fetchInitialUnreadCount();
        }
        this.updateMainMenu();
    },

    computed: {
    cartTotalValue() {
        return Number(this.$store.state.cart?.totalValue ?? 0).toFixed(2);
    },
    },

    methods: {
        onMenuButtonClick(event) {
            this.$emit('menubutton-click', event);
        },

        onTopbarMenuButtonClick(event) {
            this.$emit('topbar-menubutton-click', event);
        },

        onRightMenuButtonClick(event) {
            this.$emit('right-menubutton-click', event);
        },
        toggleI18NPanel(event) {
            this.$refs.i18n.toggle(event);
        },
        toggleAccountPanel(event) {
            this.$refs.acc.toggle(event);
        },
        toggleNotiPanel(event) {
            this.$refs.noti_op.toggle(event);
        },
        toggleCartPanel(event) {
            this.$refs.cart.toggle(event);
        },
        onNotiPanelShow() {
            this.$refs.notiPanel?.refresh();
        },

        gotoShoppingCart($evt) {
            this.toggleCartPanel($evt);
            this.$router.push({ path: '/cart' });
        },

        gotoProducts($evt) {
            this.toggleCartPanel($evt);
            this.$router.push({ path: '/products' });
        },

        gotoProfile($evt) {
            this.toggleAccountPanel($evt);
            this.$gotoProfile(this);
        },

        gotoLogin($evt) {
            this.toggleAccountPanel($evt);
            this.$gotoLogin(this);
        },

        selectMmMM($evt) {
            this.toggleI18NPanel($evt);
            this.$changeLocale(this, 'mm_MM');
            this.updateMainMenu();
        },
        selectEnUs($evt) {
            this.toggleI18NPanel($evt);
            this.$changeLocale(this, 'en_US');
            this.updateMainMenu();
        },
        updateMainMenu() {
            let tempMenu = this.$store.state.appSupport.menu;

            let newMenu = tempMenu.map((m) => {
                let newLabel = (this.$store.state.i18n.messageBundle?.main_menu)[m.id];
                if (newLabel) {
                    m.label = newLabel;
                }
                if (m.items) {
                    m.items.forEach((itm) => {
                        let newSubLabel = (this.$store.state.i18n.messageBundle?.main_menu)[itm.id];
                        if (newSubLabel) {
                            itm.label = newSubLabel;
                        }
                    });
                }

                return m;
            });

            this.$store.dispatch('createMenu', newMenu);
        },
        async logout($evt) {
            try {
                this.toggleAccountPanel($evt);
                await this.authService.performLogout();
            } catch {
                console.log('Logout error.');
            } finally {
                this.$deleteUserData(this);
                this.$gotoLogin(this);
            }
        },

        formatAccName(name) {
            if (name && name.length > 1) return name.substring(0, 1);
            return name || 'G';
        },

        onKeywordSearch() {
            if (this.searchQuery.trim()) {
                this.$router.push({ path: '/search', query: { q: this.searchQuery } });
            }
        },

        // Fetches unread count on initial load
        async fetchInitialUnreadCount() {
            try {
                await this.$verifyUserData(this);
                const notis = await this.notiService.fetchNotifications(this.$store.state.user.userData.refId, 1);
                this.unreadCount = (notis.items || []).filter((n) => !n.userAckFlag).length;
            } catch {
                console.log('Failed to fetch notifications for unread count.');
            }
        },
    },
};
</script>

<style lang="scss">
.layout-wrapper .layout-topbar .topbar-menu > li > button {
    position: relative;
    display: block;
    text-align: center;
    border-radius: 10%;
    transition: background-color 0.2s, box-shadow 0.2s;
}

.logo-image2 {
    height: 25px !important;
    widows: 25px !important;
    max-width: 25px !important;
    max-height: 25px !important;
    vertical-align: middle;
    display: none;
}

.logo-image {
    display: none !important;
}

.logo-item {
    vertical-align: middle;
    display: inline !important;
    font-size: 17px;
    color: #ffffff;
    font-weight: bold;
    text-align: center;
    line-height: 2;
}

.logo-item2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    margin-left: 0.35rem;
    margin-right: 0.35rem;
    font-size: large;
    color: white;
}

.logo-item2-highlighted {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    margin-left: 0.35rem;
    margin-right: 0.35rem;
    font-size: large;
    color: white;
}

.panel-menu-item {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.panel-menu-sub-item {
    padding: 0.1rem;
    font-weight: normal;
}
.panel-menu-sub-item:hover {
    color: var(--blue-700);
    font-weight: bold;
}

.shopping-cart-badge .p-badge {
    background-color: var(--yellow-500);
    color: #000;
}

.shopping-cart-badge-extra .p-badge {
    background-color: var(--yellow-300);
    color: var(--blue-900);
    font-size: large;
}

.en-us-badge-img {
    background: url('./assets/flags/i18n/en_us.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    border-color: #fff;
    border-width: 1px;
    border-style: solid;
    padding-right: 20px;
    margin-right: 5px;
}

.mm-mm-badge-img {
    background: url('./assets/flags/i18n/mm_mm.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-color: #fff;
    border-width: 1px;
    border-style: solid;
    padding-right: 20px;
    margin-right: 5px;
}

.en-us-badge .p-badge {
    background: url('./assets/flags/i18n/en_us.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    border-color: #fff;
    background-color: var(--surface-900);
    border-width: 1px;
    border-style: solid;
}

.mm-mm-badge .p-badge {
    background: url('./assets/flags/i18n/mm_mm.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-color: #fff;
    background-color: #fff;
    border-width: 1px;
    border-style: solid;
}

.logo-item-inner {
    vertical-align: middle;
    display: inline !important;
    align-items: center;
    max-width: 125px;
}

.main-logo {
    float: middle;
    text-align: center;
}

.inner-toolbar {
    justify-content: space-between;
    align-items: center;
}

.p-link:focus {
    box-shadow: none !important;
}

.noti-anchor {
    position: relative;
}

.layout-wrapper.layout-topbar-blue .layout-topbar {
    /*background-color: var(--blue-500);*/
    background-color: #da1b1b;
    /*background: url('./assets/images/bg/bg2.jpg');*/

    .layout-topbar-search {
        /*background-color: var(--blue-600);*/
        /*background-color: #c62626;*/
        background-color: #da1b1b;
        input {
            background-color: var(--surface-100);
            padding: 7px 6px 6px 25px;
            color: var(--surface-900);
            width: 90%;
        }

        input::placeholder {
            color: var(--surface-700);
        }
    }
}

.layout-wrapper .layout-topbar .topbar-menu > li > ul {
    /*background-color: var(--pink-600);*/
    background-color: #c21d1d;
    background-color: var(--surface-100);
}

.layout-wrapper .layout-topbar .topbar-menu > li > ul button {
    /*background-color: var(--pink-600);*/
    background-color: #c21d1d;
    background-color: var(--surface-50);
    color: rgb(244, 238, 238);
    color: var(--surface-900);
    font-weight: normal;
    border-radius: 3px;
}

.layout-wrapper .layout-topbar .topbar-menu > li > ul button:hover {
    background-color: var(--blue-700);
    background-color: var(--surface-300);
    font-weight: normal;
}

@media screen and (min-width: 896px) {
    .logo-item {
        font-size: 23px;
        color: #ffffff;
    }

    .logo-item2 {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        margin-left: 0.35rem;
        margin-right: 0.35rem;
        font-size: large;
        color: white;
    }

    .logo-item-inner {
        vertical-align: middle;
        display: inline !important;
        align-items: center;
        max-width: 120px;
    }

    .logo-image {
        display: inline !important;
    }

    .logo-image2 {
        height: 25px !important;
        widows: 25px !important;
        max-width: 25px !important;
        max-height: 25px !important;
        display: inline !important;
    }

    .layout-wrapper.layout-topbar-blue .layout-topbar {
        .layout-topbar-search {
            /*background-color: var(--blue-900);*/
            background-color: #da1b1b;
            input {
                background-color: var(--surface-100);
                color: var(--surface-900);
                width: 30%;
            }

            input::placeholder {
                color: var(--surface-600);
            }
        }
    }
}

.circle-icon-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: var(--blue-900);
    background-color: #931515;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
}

.topbar-content {
    width: 1400px;
    margin-left: auto;
    margin-right: auto;
}

@media screen and (max-width: 1456px) {
    .topbar-content {
        width: 100%;
        margin: auto;
    }
}

@media screen and (min-width: 2500px) {
    .topbar-content {
        width: 90%;
        margin: auto;
    }
}

@media screen and (min-width: 4250px) {
    .topbar-content {
        width: 90%;
        margin: auto;
    }
}
</style>
